var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 25.0002C25 25.5307 24.7893 26.0394 24.4142 26.4145C24.0391 26.7895 23.5304 27.0002 23 27.0002H9C8.46957 27.0002 7.96086 26.7895 7.58579 26.4145C7.21071 26.0394 7 25.5307 7 25.0002V13.0002C7 12.4698 7.21071 11.9611 7.58579 11.586C7.96086 11.211 8.46957 11.0002 9 11.0002H23C23.5304 11.0002 24.0391 11.211 24.4142 11.586C24.7893 11.9611 25 12.4698 25 13.0002V25.0002Z",
    stroke: "#00842F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9993 8C20.9993 6.67392 20.4725 5.40215 19.5348 4.46447C18.5971 3.52678 17.3254 3 15.9993 3C14.6732 3 13.4014 3.52678 12.4637 4.46447C11.5261 5.40215 10.9993 6.67392 10.9993 8V11H20.9993V8Z",
    stroke: "#00842F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a42e0d5b.svg";
export { ForwardRef as ReactComponent };